/* app/js/src/components/common/report-window/report-window.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.container {
  min-width: 342px;
  min-height: 235px;
  position: fixed;
  right: 10px;
  top: 100px;
  background-color: #f1f3f4;
  z-index: 10;
  opacity: 1;
  transition: opacity ease-in 0.2s;
  border-radius: 3px;
  pointer-events: initial;
  -webkit-box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.2);
  box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.2);
}
.container.show {
  opacity: 1;
  pointer-events: initial;
}
.container header {
  height: 35px;
}
.container header .topHeader {
  height: 24px;
  font-size: 12px;
  font-weight: bold;
  color: #232f3a;
  position: relative;
  padding: 6px;
  line-height: 12px;
  background-color: #f1f3f4;
  cursor: all-scroll;
  border-radius: 3px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.container header .topHeader .icons {
  position: absolute;
  right: 6px;
  top: 6px;
  font-size: 0;
  z-index: 3;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.container header .topHeader .icons .close {
  display: inline-block;
  cursor: pointer;
}
.container header .topHeader .icons .close svg path {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  -ms-transform: rotate(0deg);
  -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
  transform-origin: center center;
  -webkit-transform-origin: center center;
  -ms-transform-origin: center center;
}
.container header .topHeader .icons .close svg:hover path {
  -ms-transform: rotate(270deg);
  -webkit-transform: rotate(270deg);
  transform: rotate(270deg);
}
.container header .topHeader .icons .enlarge {
  display: inline-block;
  cursor: pointer;
  margin-right: 9px;
}
.container header .topHeader.active::before {
  content: " ";
  background-color: transparent;
  position: absolute;
  left: -100%;
  top: -300%;
  width: 300%;
  height: 1600%;
  z-index: 3;
}
.container section {
  min-height: 400px;
  margin-right: 20px;
  margin-left: 20px;
  margin-bottom: 20px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
/*# sourceMappingURL=report-window.component.css.map */
